module.exports = __webpack_public_path__ + "static/media/guide_desktop_02.24f1b970.svg";